import flow from 'lodash/flow';
import AnalyticsData from '@atlassian/jira-analytics-web-react/src/components/analytics-data.tsx';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import BreadcrumbRenderer from '@atlassian/jira-breadcrumbs/src/breadcrumb-renderer/index.tsx';
import { SCREEN } from '@atlassian/jira-product-analytics-bridge';
import { connect } from '@atlassian/jira-react-redux';
import { isFirstDataLoaded, getBoardId, getBaseUrl, getProjectKey } from '../state/selectors/base';
import type { State } from '../state/types';
import List from './list';
import Overview, { type Props } from './view';

const mapStateToProps = (state: State): Props => ({
	List,
	BreadcrumbRenderer,
	isFirstDataLoaded: isFirstDataLoaded(state),
	boardId: getBoardId(state),
	baseUrl: getBaseUrl(state),
	projectKey: getProjectKey(state),
});

export default flow(
	AnalyticsData({
		attributes: {
			boardType: 'Agility',
		},
	}),
	AnalyticsSource('allReports', SCREEN),
	// @ts-expect-error - TS2589 - Type instantiation is excessively deep and possibly infinite.
	connect(mapStateToProps, {}),
)(Overview);
